import styled from "styled-components";

interface JoinProcessItemStyleProps {
  step: any;
}

export const JoinProcessBar = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const ProcessNumberBox = styled.div`
  display: flex;
  width: 38px;
  height: 20px;
  padding: 2px 6px;
  color: ${(props) => props.theme.colors.white100};
  font-weight: 800;
  background: ${(props) => props.theme.colors.primary100};
  border-radius: 4px;
  align-items: center;
  justify-content: center;
`;

export const ProcessGaugeBar = styled.div<JoinProcessItemStyleProps>`
  position: relative;
  width: 90px;
  height: 6px;
  background: ${(props) => props.theme.colors.black10};
  border-radius: 3px;

  span {
    position: absolute;
    display: inline-block;
    width: ${(props) => props.step}%;
    height: 6px;
    top: 0;
    left: 0;
    background: ${(props) => props.theme.colors.primary100};
    border-radius: 3px;
  }
`;
